import { ButtonGroup, IconButton, Icon, Flex } from '@wegroup/design-system';
import React from 'react';
import useTracking from '../../../../../../common/src/hooks/tracking/useTracking';

interface Props {
  onAdd?: () => void;
  isAddDisabled?: boolean;
  onEdit: () => void;
  isEditDisabled?: boolean;
  onRemove: () => void;
  isRemoveDisabled?: boolean;
  eventName?: string;
}

const TableRowActions: React.FC<Props> = ({
  onEdit,
  isEditDisabled,
  onRemove,
  isRemoveDisabled,
  onAdd,
  isAddDisabled,
  eventName,
}) => {
  const { trackEvent } = useTracking();

  const handleAdd = () => {
    if (eventName)
      trackEvent(`Add ${eventName} in advisory report creation flow`);
    onAdd?.();
  };

  const handleEdit = () => {
    if (eventName)
      trackEvent(`Edit ${eventName} in advisory report creation flow`);
    onEdit();
  };

  const handleRemove = () => {
    if (eventName)
      trackEvent(`Remove ${eventName} in advisory report creation flow`);
    onRemove();
  };

  return (
    <Flex justifyContent="flex-end">
      <ButtonGroup variant="white" isAttached>
        {onAdd && (
          <IconButton
            size="sm"
            borderRight="none"
            aria-label="add"
            onClick={handleAdd}
            icon={<Icon boxSize={5} name="GeneralActionsAdd" />}
            isDisabled={isAddDisabled}
          />
        )}
        <IconButton
          onClick={handleEdit}
          size="sm"
          icon={<Icon name="GeneralActionsEditDocument" boxSize={5} />}
          aria-label="Edit"
          isDisabled={isEditDisabled}
        />
        <IconButton
          borderLeft="none"
          onClick={handleRemove}
          size="sm"
          icon={
            <Icon name="GeneralActionsThrash" boxSize={5} color="danger.main" />
          }
          aria-label="Remove"
          isDisabled={isRemoveDisabled}
        />
      </ButtonGroup>
    </Flex>
  );
};

export default TableRowActions;
